import {
    DatalabFeature,
    DatalabFeatureAccessCount,
} from "@biggeo/bg-server-lib/studio";

import { Initialized, RemoteData, map } from "@vividtheory/remotedata";
import { ActionType, action } from "typesafe-actions";
import { userActions } from "../../user/redux/model";

interface IModel {
    readonly datalabFeatureAccess: Partial<
        Record<DatalabFeature, RemoteData<string, DatalabFeatureAccessCount>>
    >;
}

const initialState: IModel = {
    datalabFeatureAccess: {},
};

export const paywallActions = {
    setDatalabFeatureAccess: (
        feature: DatalabFeature,
        v: RemoteData<string, DatalabFeatureAccessCount>
    ) => action("SET_DATALAB_FEATURE_ACCESS", { feature, v }),
    incrementDatalabFeatureAccessQuantity: (
        feature: DatalabFeature,
        v: number
    ) => action("INCREMENT_DATALAB_FEATURE_ACCESS_QUANTITY", { feature, v }),
    decrementDatalabFeatureAccessQuantity: (
        feature: DatalabFeature,
        v: number
    ) => action("DECREMENT_DATALAB_FEATURE_ACCESS_QUANTITY", { feature, v }),
};
export const paywallReducer = (
    // biome-ignore lint/style/useDefaultParameterLast: <explanation>
    state: IModel = initialState,
    action: ActionType<typeof paywallActions> | ActionType<typeof userActions>
): IModel => {
    if (!action) return state;

    switch (action.type) {
        case "SET_DATALAB_FEATURE_ACCESS": {
            return {
                ...state,
                datalabFeatureAccess: {
                    ...state.datalabFeatureAccess,
                    [action.payload.feature]: action.payload.v,
                },
            };
        }
        case "INCREMENT_DATALAB_FEATURE_ACCESS_QUANTITY": {
            return {
                ...state,
                datalabFeatureAccess: {
                    ...state.datalabFeatureAccess,
                    [action.payload.feature]: map((value) => {
                        return {
                            ...value,
                            currentQuantity:
                                value.currentQuantity + action.payload.v,
                        };
                    }, state.datalabFeatureAccess[action.payload.feature] ||
                        new Initialized()),
                },
            };
        }
        case "DECREMENT_DATALAB_FEATURE_ACCESS_QUANTITY": {
            return {
                ...state,
                datalabFeatureAccess: {
                    ...state.datalabFeatureAccess,
                    [action.payload.feature]: map((value) => {
                        return {
                            ...value,
                            currentQuantity:
                                value.currentQuantity - action.payload.v,
                        };
                    }, state.datalabFeatureAccess[action.payload.feature] ||
                        new Initialized()),
                },
            };
        }
        case "REMOVE": {
            return initialState;
        }
        default:
            return state;
    }
};
